export default "__VITE_ASSET__DI3g4ZzM__"